import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appCtrlClick]',
  standalone: true,
})
export class CtrlClickDirective {
  @Output() appCtrlClick = new EventEmitter<MouseEvent>();

  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    this.handleClick(event);
  }

  @HostListener('contextmenu', ['$event'])
  onContextMenu(event: MouseEvent): void {
    this.handleClick(event);
  }

  handleClick(event: MouseEvent) {
    if (event.ctrlKey) {
      event.preventDefault();
      this.appCtrlClick.emit(event);
    }
  }
}
